const REPORT_STATUS = {
  ALL: "All",
  ADC_APPROVED: "ADC_APPROVED",
  REVISION_REQUIRED: "REVISION_REQUIRED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  UNDER_PROCESS: "UNDER_PROCESS",
};
export default REPORT_STATUS;
